import { getProductTypeFromMetadata } from '../index';
import { buildSpanModel } from './buildSpanModel';
import { computeStructuralLocks } from './structuralLocks';
import { computeInclusiveLocks } from './inclusiveLocks';

export function computeDraggabilityMap(design, productGroupsByType, metadata, options = {}) {
  const { alwaysLockBaseFull = false } = options;
  const products = design.products;
  const getType = (product) => getProductTypeFromMetadata(metadata?.[product.choiceId]?.metadata);

  const baseFull = products.find((product) => getType(product) === 'full');
  const baseFullId = baseFull?.stackItemId || null;

  // Build span model
  const spanModel = buildSpanModel(products, productGroupsByType, metadata);

  // Structural locks
  const structuralLocked = computeStructuralLocks(spanModel, metadata, baseFullId);

  // Inclusive locks
  const inclusiveLocked = computeInclusiveLocks(spanModel, metadata);

  const { productSpanInfo, hasAbove } = spanModel;

  // Final map
  const map = {};
  products.forEach((product) => {
    const id = product.stackItemId;
    const type = getType(product);

    if (id === baseFullId) {
      map[id] = alwaysLockBaseFull ? false : !hasAbove[id];
      return;
    }

    if (structuralLocked.has(id) || inclusiveLocked.has(id)) {
      map[id] = false;
      return;
    }

    if (type === 'full') {
      map[id] = true; // non-base full always draggable
      return;
    }

    map[id] = true;
  });

  return map;
}
